<template>
    <Section id="benefits" class="bg-gray-200">
        <template #section>
            {{ $t('budgets_landing_page.benefits') }}
        </template>
        <template #title>
            {{ $t('budgets_landing_page.benefits_subtitle') }}
        </template>
        <div class="md:grid-cols-3 grid gap-12">
            <div v-for="benefit in benefits">
                <div class="w-9 h-9 inline-flex items-center justify-center mb-4 bg-blue-500 rounded-lg">
                    <span :class="[benefit.iconName, 'icon icon-lg text-blue-100']"></span>
                </div>
                <h3 class="mt-0 mb-2 text-lg font-medium">
                    {{ benefit.title }}
                </h3>
                <p class="mb-0 text-sm font-normal">
                    {{ benefit.description }}
                </p>
            </div>
        </div>
    </Section>
</template>

<script>
import Section from '../../../../shared/section.vue';

export default {
    components: {
        Section,
    },

    computed: {
        benefits() {
            const benefits = [
                {
                    title: this.$t('budgets_landing_page.benefits_card_1_title'),
                    description: this.$t('budgets_landing_page.benefits_card_1_description'),
                    iconName: 'icon-cog',
                },
                {
                    title: this.$t('budgets_landing_page.benefits_card_2_title'),
                    description: this.$t('budgets_landing_page.benefits_card_2_description'),
                    iconName: 'icon-shield',
                },
                {
                    title: this.$t('budgets_landing_page.benefits_card_3_title'),
                    description: this.$t('budgets_landing_page.benefits_card_3_description'),
                    iconName: 'icon-euro',
                },
                {
                    title: this.$t('budgets_landing_page.benefits_card_4_title'),
                    description: this.$t('budgets_landing_page.benefits_card_4_description'),
                    iconName: 'icon-comments',
                },
                {
                    title: this.$t('budgets_landing_page.benefits_card_5_title'),
                    description: this.$t('budgets_landing_page.benefits_card_5_description'),
                    iconName: 'icon-sliders',
                },
                {
                    title: this.$t('budgets_landing_page.benefits_card_6_title'),
                    description: this.$t('budgets_landing_page.benefits_card_6_description'),
                    iconName: 'icon-bell',
                },
                {
                    title: this.$t('budgets_landing_page.benefits_card_7_title'),
                    description: this.$t('budgets_landing_page.benefits_card_7_description'),
                    iconName: 'icon-eye',
                },
                {
                    title: this.$t('budgets_landing_page.benefits_card_8_title'),
                    description: this.$t('budgets_landing_page.benefits_card_8_description'),
                    iconName: 'icon-line-chart',
                },
                {
                    title: this.$t('budgets_landing_page.benefits_card_9_title'),
                    description: this.$t('budgets_landing_page.benefits_card_9_description'),
                    iconName: 'icon-check-circle',
                },
            ];

            return benefits;
        },
    },
};
</script>
